module.exports = __webpack_public_path__ + "img/builder-31.7f4e4b29.webp";